/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCTemplateCreateBody } from '../models/TCTemplateCreateBody';
import type { TCTemplateDeleteResponse } from '../models/TCTemplateDeleteResponse';
import type { TCTemplateKind } from '../models/TCTemplateKind';
import type { TCTemplateListResponse } from '../models/TCTemplateListResponse';
import type { TCTemplateRecord } from '../models/TCTemplateRecord';
import type { TCTemplateUpdateBody } from '../models/TCTemplateUpdateBody';
import type { TCTemplateVersionsListResponse } from '../models/TCTemplateVersionsListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V1TemplatesService {
    /**
     * @param limit
     * @param pageToken
     * @param kind Optional template kind filter.
     * @param origin Optional template origin filter.
     * @param tag Optional template tag filter.
     * @returns TCTemplateListResponse Ok
     * @throws ApiError
     */
    public static listTemplates(
        limit?: number,
        pageToken?: string,
        kind?: TCTemplateKind,
        origin?: string,
        tag?: string,
    ): CancelablePromise<TCTemplateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/templates',
            query: {
                'limit': limit,
                'pageToken': pageToken,
                'kind': kind,
                'origin': origin,
                'tag': tag,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns TCTemplateRecord Ok
     * @throws ApiError
     */
    public static createTemplate(
        requestBody: TCTemplateCreateBody,
    ): CancelablePromise<TCTemplateRecord> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param key
     * @returns TCTemplateVersionsListResponse Ok
     * @throws ApiError
     */
    public static listTemplateVersions(
        key: string,
    ): CancelablePromise<TCTemplateVersionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/templates/by-key/{key}/versions',
            path: {
                'key': key,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param templateId
     * @returns any Ok
     * @throws ApiError
     */
    public static getTemplate(
        templateId: string,
    ): CancelablePromise<TCTemplateRecord | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            errors: {
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param templateId
     * @param requestBody
     * @returns TCTemplateRecord Ok
     * @throws ApiError
     */
    public static updateTemplate(
        templateId: string,
        requestBody: TCTemplateUpdateBody,
    ): CancelablePromise<TCTemplateRecord> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param templateId
     * @returns TCTemplateDeleteResponse Ok
     * @throws ApiError
     */
    public static deleteTemplate(
        templateId: string,
    ): CancelablePromise<TCTemplateDeleteResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            errors: {
                404: `Resource not found`,
                500: `Internal Server Error`,
            },
        });
    }
}
